import gql from 'graphql-tag'

export const createBarcodeSetting = gql`
  mutation CreateBarcodeSetting(
    $accountId: Int!
    $barcodeLabelId: Int!
    $output: String!
    $digits: Int
    $prefix: String
    $startNumber: Float
    $name: String!
    $dataSource: String!
    $entityId: Int
    $fieldId: Int
    $id: ID
  ) {
    createBarcodeSetting(
      input: {
        id: $id
        accountId: $accountId
        barcodeLabelId: $barcodeLabelId
        output: $output
        digits: $digits
        prefix: $prefix
        startNumber: $startNumber
        name: $name
        dataSource: $dataSource
        entityId: $entityId
        fieldId: $fieldId
      }
    ) {
      barcodeSettings {
        id
        accountId
        entityId
        barcodeLabelId
      }
      errors
    }
  }
`
